import type { SxProps, Theme } from '@mui/material';

/** Quieter secondary SSO controls — password login stays visually primary. */
export const ssoButtonSx: SxProps<Theme> = {
  minHeight: 36,
  textTransform: 'none',
  justifyContent: 'center',
  position: 'relative',
  backgroundColor: '#ffffff',
  borderColor: '#b7c2d0',
  color: '#3d4f63',
  fontWeight: 400,
  fontSize: '0.8125rem',
  px: 4,
  '&:hover': {
    borderColor: '#8494a7',
    backgroundColor: '#ffffff',
    color: '#1a2332',
  },
  '&.Mui-disabled': {
    borderColor: '#d5dde8',
    color: '#8494a7',
    backgroundColor: '#eef2f7',
  },
};
